import { tabAccessControl } from "../../../_helpers/access-control";

let ProcessCapacityTabs = [
  {
    text: "Shifts",
    path: `/process-capacity`,
    applicationFeatureCode: "ProcessCapacity",
  },
  {
    text: "Exceptions",
    path: '/exception-list',
    applicationFeatureCode: "ProcessCapacity",
  }
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(ProcessCapacityTabs).findIndex((x) => x.text == tabName);
}

export { ProcessCapacityTabs, GetIndexByTabName };
